var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerawalleticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6.4,
    fill: "#FFEE55"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3877 7.90031C17.884 9.95672 17.7162 11.7656 17.0129 11.9406C16.3096 12.1155 15.3371 10.5903 14.8408 8.53392C14.3445 6.47751 14.5122 4.66862 15.2155 4.49365C15.9188 4.31868 16.8913 5.84389 17.3877 7.90031Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5835 9.66832C24.4843 8.50334 22.2974 8.8191 20.699 10.3736C19.1006 11.9281 18.6959 14.1327 19.7951 15.2977C20.8943 16.4627 23.0811 16.1469 24.6795 14.5924C26.278 13.0379 26.6827 10.8333 25.5835 9.66832Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8411 27.5071C17.5444 27.3321 17.6875 25.4209 17.1607 23.2383C16.6339 21.0556 15.6367 19.4281 14.9334 19.6031C14.23 19.778 14.087 21.6892 14.6138 23.8719C15.1406 26.0545 16.1378 27.6821 16.8411 27.5071Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67161 10.7349C11.7007 11.3333 13.1833 12.383 12.9832 13.0796C12.7831 13.7761 10.976 13.8557 8.94689 13.2574C6.91781 12.659 5.43516 11.6093 5.63528 10.9127C5.83541 10.2161 7.64253 10.1365 9.67161 10.7349Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8412 18.6005C24.9948 19.2356 26.5784 20.3151 26.3783 21.0117C26.1782 21.7082 24.2701 21.7581 22.1164 21.123C19.9628 20.4879 18.3792 19.4083 18.5793 18.7118C18.7794 18.0152 20.6875 17.9654 22.8412 18.6005Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9548 17.139C11.4516 16.6174 9.80117 17.3765 8.26843 18.8346C6.7357 20.2926 5.90108 21.8974 6.40426 22.419C6.90743 22.9406 8.55787 22.1815 10.0906 20.7234C11.6233 19.2654 12.458 17.6606 11.9548 17.139Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerawalleticon);
export default __webpack_public_path__ + "static/media/perawallet.icon.a7b5818d2e85f3690c3a8eb5e55c466f.svg";
export { ForwardRef as ReactComponent };